import React from 'react'
import { GoogleLogin, CredentialResponse } from '@react-oauth/google'

interface GoogleLoginButtonProps {
  onSuccess: (response: CredentialResponse) => void
  onError: () => void
  disabled?: boolean
}

export const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess, onError, disabled = false }) => {
  return (
    <GoogleLogin
      onSuccess={(credentialResponse) => {
        onSuccess(credentialResponse)
      }}
      onError={() => {
        onError()
      }}
      locale="es-ES"
      useOneTap={false}
    />
  )
}
